import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"
import { Link } from "react-router-dom"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          {/* Dark theme version */}
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <span className="logo-gradient-text fw-bold">OR</span>
            </span>
            <span className="logo-lg">
              <span className="logo-gradient-text fw-bold fs-4">
                OmniReport
              </span>
            </span>
          </Link>

          {/* Light theme version */}
          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <span className="logo-gradient-text-light fw-bold">OR</span>
            </span>
            <span className="logo-lg">
              <span className="logo-gradient-text-light fw-bold fs-4">
                OmniReport
              </span>
            </span>
          </Link>
        </div>

        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>

        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
